import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import {
  Container,
  SwipeableDrawer,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useWindowSize } from "react-use";
import { PlayerProps, PlayerStateProps } from "../types";
import SelectStation from "../SelectStation";
import Song from "../Song";
import SongInfoButton from "../SongInfoButton";
import { calcAlbumArtSize } from "../AlbumArt";
import * as S from "./PlayerDrawer.styles";
import DonateButton from "../../DonateButton";
import DrawerToggleButton from "./DrawerToggleButton";
import Logo from "../../Logo";

type PlayerDrawerProps = PlayerStateProps &
  PlayerProps & {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    isFreeTrial?: boolean;
  };

const PlayerDrawer = (props: PlayerDrawerProps) => {
  const { open, setOpen, forceMobileView, isFreeTrial } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const { width, height } = useWindowSize();
  const [albumArtSize, setAlbumArtSize] = useState<number>(
    calcAlbumArtSize(width, height, 16)
  );

  useEffect(() => {
    setAlbumArtSize(calcAlbumArtSize(width, height, 16));
  }, [width, height]);

  useEffect(() => {
    if (!forceMobileView && !isMobile && open) {
      setOpen(false);
    }
  }, [forceMobileView, isMobile, open, setOpen]);

  return (
    <SwipeableDrawer
      className={S.classes.root}
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      anchor="bottom"
      PaperProps={{
        sx: {
          height: "100%",
          backgroundColor: isFreeTrial ? "#262627" : "background.default",
        },
      }}
      sx={(theme) => ({
        zIndex: theme.zIndex.player - 1,
      })}
    >
      {!isFreeTrial && (
        <Toolbar sx={{ backgroundColor: "background.paper" }}>
          <Container
            disableGutters
            maxWidth="sm"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: !forceMobileView ? "space-between" : "flex-end",
            }}
          >
            {!forceMobileView && (
              <DrawerToggleButton open={open} setOpen={setOpen} />
            )}

            <DonateButton size={isMobile ? "small" : "medium"} />
          </Container>
        </Toolbar>
      )}

      {isFreeTrial && (
        <div
          style={{
            alignItems: "center",
            textAlign: "center",
            paddingTop: "10px",
          }}
        >
          <Logo height={"53px"} />
          <p
            style={{
              margin: "10px 0 5px",
              fontFamily: "futura-pt",
              fontWeight: 400,
              fontSize: "1em",
              color: "#b0b0b0",
            }}
          >
            Streaming Ad-Free. Non-Profit.
          </p>
          <h1
            style={{
              fontFamily: "futura-pt",
              fontWeight: 500,
              fontSize: "2.5em",
              color: "#fff",
              marginTop: "5px",
            }}
          >
            Laid-Back Jazz
          </h1>
        </div>
      )}

      <S.ContentContainer maxWidth="sm">
        <S.ContentStack spacing={4}>
          {!isFreeTrial && <SelectStation fullWidth />}

          <Song
            disableTextTruncation
            AlbumArtProps={{
              size: albumArtSize,
              sx: { mb: 4 },
            }}
            actionButton={<SongInfoButton />}
          />
        </S.ContentStack>
      </S.ContentContainer>
    </SwipeableDrawer>
  );
};

export default PlayerDrawer;
